"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgChevronSDown(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "7 -4 10 24" }, props),
        React.createElement("path", { d: "M8.53 5.47a.75.75 0 00-1.06 1.06l4 4a.75.75 0 001.06 0l4-4a.75.75 0 00-1.06-1.06L12 8.94z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('ChevronSDown')(SvgChevronSDown);
//# sourceMappingURL=ChevronSDown.js.map